<template>
  <div class="container">
    <div class="form-group">
      <label>Select Template</label>
      <v-select
        v-model="selected_template"
        :options="templates"
        label="name"
        placeholder="Select Template"
        required
      />
    </div>
    <div class="form-group">
      <input
        id="terms"
        v-model="terms"
        type="checkbox"
      >
      <label
        for="terms"
        style="margin-left: 10px;"
      >I have read the <a
        href="#"
        @click.prevent="show_terms=true"
      >terms
        and conditions.</a></label>
    </div>
    <hr>
    <div class="form-group">
      <div
        id="bid-bond-template"
        class="preview"
        style="background: #fff url(/img/sample.png) no-repeat; background-size: contain; background-position-x: center;"
      >
        <div v-html="preview" />
      </div>
    </div>
    <hr>
    <div
      class="form-group"
      style="text-align: right; padding: 0 20px;"
    >
      <button
        class="btn btn-primary btn-sm"
        @click.prevent="selectTemplate"
      >
        Proceed
      </button>
      <a
        href="#"
        class="btn btn-info pull-left btn-sm"
        @click.prevent="$emit('back')"
      >Previous</a>
    </div>
    <modal
      :show-modal="show_terms"
      @close="show_terms=false"
    >
      <template v-slot:header>
        <h5>Terms and Conditions</h5>
      </template>
      <div>
        <bid-terms />
      </div>
      <hr>
      <div class="form-group">
        <a
          href="#"
          class="btn btn-primary"
          @click.prevent="show_terms = false; terms = true;"
        >Accept Terms and
          Conditions</a>
        <a
          href="#"
          class="btn btn-danger pull-right"
          @click.prevent="show_terms = false"
        >Cancel</a>
      </div>
    </modal>
  </div>
</template>

<script>
import BidTerms from "@/components/Guest/BidTerms.vue";

export default {
  components: {
    BidTerms
  },
  props: {
    current: {
      type: Object,
    },
  },
  data() {
    return {
      templates: [],
      selected_template: {},
      preview: '',
      terms: false,
      show_terms: false
    }
  },
  watch: {
    selected_template(n) {
      if (!n) return;
      this.$axios.post('/api/v1/performances/preview', {
        "company_id": this.current.company.company_unique_id,
        "counterparty_id": this.current.counterparty_id,
        "addressee": this.current.addressee,
        "company": this.current.company.name,
        "joint_venture": this.current.joint_venture,
        "purpose": this.current.purpose,
        "tender_no": this.current.tender_no,
        "contract_no": this.current.contract_no,
        "effective_date": this.current.start_date,
        "expiry_date": this.current.end_date,
        "template_secret": this.selected_template.secret,
        "amount": this.current.amount,
        "period": this.current.period,
        "currency": this.current.currency,
      }).then(response => {
        this.preview = response.data;
      });
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      const self = this;
      this.$axios.get('/api/v1/performance-templates/all').then(response => {
        this.templates = response.data;
        if (this.current.template) {
          const selected_t = this.templates.filter(res => {
            return res.secret === self.current.template;
          });
          if (selected_t) {
            this.selected_template = selected_t[0];
          }
        } else {
          this.selected_template = this.templates[0];
        }
      });
    },

    selectTemplate() {
      if (this.terms) {
        return this.$emit('selected', this.selected_template.secret);
      } else {
        window.scrollTo(0, 0);
        this.$toastr.e('Please accept the terms and conditions');
      }
    }
  }
}
</script>
